module.exports = __webpack_public_path__ + "img/glasses.9bdd7420.jpg";